import React, { useEffect, useCallback } from "react";
import { Card, Row, Col, Button, Grid } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { SearchOutlined } from "@ant-design/icons";

import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import RecordDateFilter from "../../../../components/filters/RecordDateFilter";
import { setFilters } from "../journalRecordSlice";
import { useDefaultDateRange } from "../../../../hooks/useDefaultDateRange";
import {
  fetchJournalRecord,
  fetchAccountsBySearch,
} from "../journalRecordThunk";
import {
  fetchUsers,
  fetchCustomers,
} from "../../../../store/commonThunks/lookups";
import CommonDateRangeFilter from "../../../../components/common/filters/CommonDateRangeFilter";

const JournalRecordFilters = () => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.journalRecord);
  const lookups = useSelector((state) => state.lookups);

  const {useBreakpoint} = Grid; 
  const screens = useBreakpoint();

  useDefaultDateRange(setFilters, filters, "today");

  useEffect(() => {
    dispatch(fetchUsers());
    dispatch(fetchCustomers());
  }, [dispatch]);

  const handleFilterChange = (field, value) => {
    if (field === "filterType") {
      // reset all filters when filterType changes
      dispatch({ type: "journalRecord/resetFilters" });
      dispatch(setFilters({ filterType: value }));
    } else {
      dispatch(setFilters({ [field]: value }));
    }
    // dispatch(setFilters({ [field]: value }));
    dispatch({ type: "journalRecord/resetList" });
  };

  const handleSubmit = () => {
    dispatch(fetchJournalRecord({ filters }));
  };

  const searchAccount = useCallback(
    (text) => dispatch(fetchAccountsBySearch(text)),
    [dispatch]
  );

  return (
    <Card className="mb-4 shadow-md rounded-xl">
      <Row gutter={16} style={{ alignItems: "center" }}>
        {/* Filter Type */}
        <Col flex="1 1 220px" style={{ minWidth: 200 }}>
          <label>Filter Type</label>
          <SearchListAutoComplete
            optionsList={[
              { sale_id: "All", display_text: "All" },
              { sale_id: "By Account", display_text: "By Account" },
              { sale_id: "By User", display_text: "By User" },
            ]}
            value={{ value: filters.filterType, label: filters.filterType }}
            onSelect={(obj) => handleFilterChange("filterType", obj?.sale_id)}
            placeholder="Filter Type"
          />
        </Col>

        {/* Account (only if By Account) */}
        {filters.filterType === "By Account" && (
          <Col flex="1 1 220px" style={{ minWidth: 200 }}>
            <label>Search Account</label>

            <SearchListAutoComplete
              entityType="account"
              searchThunk={searchAccount}
              resultSelector={(state) => state.journalRecord.accounts}
              onSelect={(obj) => handleFilterChange("accountId", obj?.sale_id)}
              placeholder="Account"
              showAddNew={false}
            />
          </Col>
        )}

        {/* User (only if By User) */}
        {filters.filterType === "By User" && (
          <Col flex="1 1 220px" style={{ minWidth: 200 }}>
            <label>Search User</label>
            <SearchListAutoComplete
              entityType="user"
              optionsList={lookups.users.map((u) => ({
                sale_id: u.id,
                display_text: u.full_name,
              }))}
              onSelect={(obj) => handleFilterChange("userId", obj?.sale_id)}
              placeholder="User"
            />
          </Col>
        )}

        {/* Record Type */}
        {filters.filterType !== "By Account" && (
          <Col flex="1 1 220px" style={{ minWidth: 200 }}>
            <label>Record Type</label>
            <SearchListAutoComplete
              optionsList={[
                { sale_id: "without details", display_text: "Without Details" },
                { sale_id: "with details", display_text: "With Details" },
              ]}
              value={{ value: filters.recordType, label: filters.recordType }}
              onSelect={(obj) => handleFilterChange("recordType", obj?.sale_id)}
              placeholder="Record Type"
            />
          </Col>
        )}
        {/* Date Range */}
        <CommonDateRangeFilter
        filters={filters}
        onChange={(fromDate, toDate) => {
        handleFilterChange("fromDate", fromDate);
        handleFilterChange("toDate", toDate);
        }}
      />


        {/* Report Button */}
        <Col
          span={ screens.md && 3}
          style={{ display: "flex", alignItems: "flex-end", height: 58,  width: !screens.md && "100%" }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleSubmit}
            style={{height: 35.19}}
            block
          >
            Report
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default JournalRecordFilters;
